<script setup lang="ts">
const prefix = 'components.results.filters';

const properties = defineProps<{ loading?: boolean }>();

const stopsStore = useStopsFilterStore();
const hoursStore = useHoursFilterStore();
const airlinesStore = useAirlinesFilterStore();
const searchCriteriaStore = useSearchCriteriaStore();
</script>

<template>
  <div class="flex min-w-65 max-w-65 flex-col">
    <ResultsFiltersAccordionWrapper
      :trigger-button-label="$t(`${prefix}.stops`)"
      :has-active-filters="stopsStore.hasActiveFilters"
      :loading="properties.loading"
    >
      <ResultsFiltersStops
        :loading="properties.loading"
        size="s"
      />
    </ResultsFiltersAccordionWrapper>
    <UiCustomSeparatorLine color-class="bg-gray-300" />
    <ResultsFiltersAccordionWrapper
      :trigger-button-label="$t(`${prefix}.hours`)"
      :has-active-filters="hoursStore.hasActiveFilters"
      :loading="properties.loading"
    >
      <ResultsFiltersHours
        :loading="properties.loading"
        size="s"
      />
    </ResultsFiltersAccordionWrapper>
    <UiCustomSeparatorLine color-class="bg-gray-300" />
    <ResultsFiltersVerticalSingleDestination
      v-if="!searchCriteriaStore.committedIsMultiDestination"
      :loading="properties.loading"
    />
    <ResultsFiltersAccordionWrapper
      :trigger-button-label="$t(`${prefix}.airlines`)"
      :has-active-filters="airlinesStore.hasActiveFilters"
      :loading="properties.loading"
    >
      <ResultsFiltersAirlines :loading="properties.loading" />
    </ResultsFiltersAccordionWrapper>
  </div>
</template>
